// Observe cart quantity changes
document.addEventListener("DOMContentLoaded", () => {
  const cartElement = document.querySelector("body");

  if (cartElement) {
    // Create observer to watch for changes to cart quantity field
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const quantityField = mutation.target.closest(".cart-drawer__item-qty");

        if (quantityField) {
          // Cart quantity field changed, trigger callback
          const newQty = parseInt(quantityField.textContent, 10);
          handleCartQuantityChange(newQty);
        }
      });
    });

    // Start observing cart quantity elements
    observer.observe(cartElement, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
});

// Callback when cart quantity changes
function handleCartQuantityChange(newQuantity) {
  // Handle quantity change here
  const quantityElements = document.querySelectorAll(".js-cart-count");
  quantityElements.forEach((element) => {
    element.textContent = newQuantity;
  });
}
